module.exports = __webpack_public_path__ + "static/media/Save.e0e5f87a.svg";